import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { getCookie, setCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class StickyAdFall26Widget extends Widget {
  componentWillMount() {
    //if the paywall postmeta is set, never render this component
    if (window.has_paywall) {
      this.state.dismissed = true;
      return;
    };
    
    this.toggleDismiss = this.toggleDismiss.bind(this);

    if (getCookie("tpm_sticky_ad_fall_26_dismissed")) {
      this.state.dismissed = true;
    }
  }

  componentDidMount() {
  }

  toggleDismiss(e) {
    e.preventDefault();
    e.stopPropagation();
    setCookie("tpm_sticky_ad_fall_26_dismissed", "1", 0.25); //0.25 days = 6 hours
    this.setState({ dismissed: true });
  }

  get hrefDirect() {
    const promo = "&promo=PrimeFor50";
    return `https://accounts.talkingpointsmemo.com/membership?plan=prime_year${promo}`;
  }

  renderContent() {

    if (this.state.dismissed) return null;
    
    return (
      <div className={`StickyAdFall26`}>
        <div
          className={`StickyAdFall26__Inner`}
        >
          <div className="StickyAdFall26__Text">Reader-supported. not billionaire controlled.</div>
          <div className="StickyAdFall26__CTA">
            <a class="Button --red-hollow-hover" href={this.hrefDirect}>Join for&nbsp;<s class="fw-normal">$70</s>&nbsp;$50&nbsp;<span class="fw-normal">for&nbsp;the&nbsp;first&nbsp;year</span></a>
          </div>
          <div className="StickyAdFall26__Dismiss" onClick={this.toggleDismiss}>
            <Icon name='xmark' style="light" /> 
          </div>
        </div>
      </div>
    );
  }
}
